import { render, staticRenderFns } from "./meandxiao.vue?vue&type=template&id=9794e5f6&scoped=true&"
import script from "./meandxiao.vue?vue&type=script&lang=js&"
export * from "./meandxiao.vue?vue&type=script&lang=js&"
import style0 from "./meandxiao.vue?vue&type=style&index=0&id=9794e5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9794e5f6",
  null
  
)

export default component.exports